import {addToCart, previewProduct} from './index'
import find from 'lodash/find'

function mapProductPA(ProductPA, selectedDesigns) {
  return ProductPA.map((productPA) => ({
    Name: productPA.Name,
    NeedToDropCustomColors: false,
    SelectedDesignId: selectedDesigns[productPA.Name]?.id,
    Tag: productPA.Tag
  }))
}

function mapSizeQty(sizes, selectedSize, quantity) {
  return sizes.map((size) => ({
    n: size.Name,
    q: size.Name.toLowerCase() === selectedSize.toLowerCase() ? quantity : 0
  }))
}

export const addProductToCart =
  ({cartLineItemID, color, productID, quantity, selectedDesigns, size}) =>
  (dispatch, getState) => {
    const {
      store_products: {
        items: {ProductOptions}
      },
      product_designs: {
        items: {productMain: productDesigns}
      }
    } = getState()

    const selectedProductOption = find(ProductOptions, {
      SanitizedColorName: color
    })

    return dispatch(
      addToCart.create({
        options: {
          body: {
            cartLineItemID,
            nnlist: [],
            orderType: 0,
            productID,
            productOption: color,
            productPA: mapProductPA(productDesigns.ProductPA, selectedDesigns),
            sizeQty: mapSizeQty(selectedProductOption.Sizes, size, quantity),
            storeID: productDesigns.StoreID
          }
        }
      })
    )
  }

export const fetchProductDesignsPreview = ({
  productPA,
  selectedActivityTag,
  selectedColorName,
  selectedDesigns,
  selectedSize,
  quantity = 1,
  personalization = {}
}) => {
  return (dispatch, getState) => {
    const {
      store_products: {
        items: {ProductID, ProductOptions}
      },
      product_designs: {
        items: {productMain: productDesigns}
      }
    } = getState()

    const selectedProductOption = find(ProductOptions, {
      SanitizedColorName: selectedColorName
    })

    return dispatch(
      previewProduct.create({
        query: {
          productPAName: productPA.Name,
          selectedDesignId: selectedDesigns[productPA.Name]?.id
        },
        options: {
          body: {
            printableArea: productPA.Name,
            productID: ProductID,
            productOption: selectedColorName,
            productOptionRequest: false,
            productPA: mapProductPA(productDesigns.ProductPA, selectedDesigns),
            requestDesigns: true,
            sizeQty: mapSizeQty(
              selectedProductOption.Sizes,
              selectedSize,
              quantity
            ),
            storeID: productDesigns.StoreID,
            userData: {
              ClassYear: personalization.classYear,
              PlayerName: personalization.playerName,
              PlayerNumber: personalization.playerNumber,
              SelectedActivityTag: selectedActivityTag
            }
          }
        }
      })
    )
  }
}
